
import { defineComponent, PropType } from "vue";

import Player from "@/models/Player";

import CardDeck from "@/components/Elements/CardDeck.vue";
import ResourceCard from "@/components/Elements/ResourceCard.vue";
import DevelopmentCard from "@/components/Elements/DevelopmentCard.vue";

export default defineComponent({
  props: {
    player: { type: Object as PropType<Player>, required: true },
  },
  components: { CardDeck, ResourceCard, DevelopmentCard },
});
